import React from 'react';

interface ISvgProps {
	width?: string;
	height?: string;
	className?: string;
	onClick?: () => void;
}

const CircularMinusIcon: React.FC<ISvgProps> = ({ width = '16', height = '16', className, onClick }) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox='0 0 16 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
			onClick={onClick}>
			<g clip-path='url(#clip0_1366_5768)'>
				<g clip-path='url(#clip1_1366_5768)'>
					<path
						d='M7.99951 14.999C6.143 14.999 4.36252 14.2615 3.04976 12.9488C1.73701 11.636 0.999512 9.85554 0.999512 7.99902C0.999512 6.14251 1.73701 4.36203 3.04976 3.04928C4.36252 1.73652 6.143 0.999023 7.99951 0.999023C9.85603 0.999023 11.6365 1.73652 12.9493 3.04928C14.262 4.36203 14.9995 6.14251 14.9995 7.99902C14.9995 9.85554 14.262 11.636 12.9493 12.9488C11.6365 14.2615 9.85603 14.999 7.99951 14.999ZM7.99951 15.999C10.1212 15.999 12.1561 15.1562 13.6564 13.6559C15.1567 12.1556 15.9995 10.1208 15.9995 7.99902C15.9995 5.87729 15.1567 3.84246 13.6564 2.34217C12.1561 0.841878 10.1212 -0.000976562 7.99951 -0.000976562C5.87778 -0.000976562 3.84295 0.841878 2.34266 2.34217C0.842367 3.84246 -0.000488281 5.87729 -0.000488281 7.99902C-0.000488281 10.1208 0.842367 12.1556 2.34266 13.6559C3.84295 15.1562 5.87778 15.999 7.99951 15.999Z'
						fill='#CC4A43'
					/>
					<path
						d='M3.99951 7.99902C3.99951 7.86642 4.05219 7.73924 4.14596 7.64547C4.23973 7.5517 4.3669 7.49902 4.49951 7.49902H11.4995C11.6321 7.49902 11.7593 7.5517 11.8531 7.64547C11.9468 7.73924 11.9995 7.86642 11.9995 7.99902C11.9995 8.13163 11.9468 8.25881 11.8531 8.35258C11.7593 8.44635 11.6321 8.49902 11.4995 8.49902H4.49951C4.3669 8.49902 4.23973 8.44635 4.14596 8.35258C4.05219 8.25881 3.99951 8.13163 3.99951 7.99902Z'
						fill='#CC4A43'
					/>
				</g>
			</g>
			<defs>
				<clipPath id='clip0_1366_5768'>
					<rect
						width='16'
						height='16'
						fill='white'
					/>
				</clipPath>
				<clipPath id='clip1_1366_5768'>
					<rect
						width='16'
						height='16'
						fill='white'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default CircularMinusIcon;
